import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ApiErrorService } from '../services/api-error.service';

/**
 * Opt-out do toast global de erro, por requisição (ex.: polling silencioso, validação que a tela
 * apresenta de forma própria):
 *   `http.get(url, { context: new HttpContext().set(SKIP_API_ERROR_TOAST, true) })`
 */
export const SKIP_API_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/**
 * Exibe o erro devolvido pela API (Problem Details) num toast com título, mensagem e "Ver mais".
 *
 * - Só atua em `/api/` e em status >= 400. O 401 fica com o `authInterceptor` (refresh/logout) e
 *   `status 0` (sem rede/CORS) não tem corpo para apresentar.
 * - Deve ser o PRIMEIRO da lista em `provideHttpClient`: assim vê o resultado final, depois do
 *   retry de refresh do `authInterceptor`.
 * - Não altera o erro: o `catchError` de cada tela continua recebendo o mesmo `HttpErrorResponse`.
 *   Os `showError`/`showApiError` que a tela dispara para a mesma falha são suprimidos
 *   (ver `ToastService.reserveApiErrorSuppression`).
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_API_ERROR_TOAST) || !req.url.includes('/api/')) {
    return next(req);
  }

  const apiErrors = inject(ApiErrorService);

  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status >= 400 && error.status !== 401) {
          apiErrors.report(error);
        }
      },
    })
  );
};
